import Panel from './panel.tsx'

import { useStore } from "../state/state.ts";
import ModalBase1 from "../modals/modal_base_1.tsx";

import ModalConfirmButton from './modal_close_button.tsx';
import './building_geometry_data.css';
import { azimuth_deg_to_roof_orientation } from '../functions.ts';
import { H } from './view.tsx';

type Row = [label: string, value: unknown, unit?: string, close?: boolean];

function format_date(value: unknown): string {
    if (value === null || value === undefined || value === "") {
        return "\u2013";
    }
    const date = value instanceof Date ? value : new Date(String(value));
    if (isNaN(date.getTime())) {
        return String(value);
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${month}.${date.getFullYear()}`;
}

function format_value(value: unknown, unit?: string): string {
    if (value === null || value === undefined || value === "") {
        return "–";
    }
    if (typeof value === "boolean") {
        return value ? "ja" : "nein";
    }
    if (typeof value === "number") {
        const formatted = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(value);
        return unit ? `${formatted} ${unit}` : formatted;
    }
    return unit ? `${String(value)} ${unit}` : String(value);
}

function DossierTable(props: { title: string, rows: Row[] }) {
    return <div className={'dossier-table-container ' + (props.rows.length > 0 && "dossier-table-container--visible")}>
        <h2>Ermittelte Gebäuderdaten</h2>
        <table className={"dossier-table"}cellSpacing="0" cellPadding="0" border={0}>
            <tbody>
                {props.rows.map(([label, value, unit, close]) => (
                    <tr key={label} className={close ? "dossier-table-row-close" : ""}>
                        <td>{label}</td>
                        <td>{format_value(value, unit)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>;
}

export default function BuildingGeometryData() {
    const pop_modal = useStore((state) => state.pop_modal);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const building_geometry_data  = useStore((state) => state.building_geometry_data);
    const dossier = useStore((state) => state.building_dossier);
    const municipality = dossier?.municipality;
    const climate = dossier?.climate;
    const zones = dossier?.zones;
    const census = dossier?.census;
    const heat_planning = dossier?.heat_planning;
    const parcel_buildings = useStore((state) => state.parcel_buildings);

    const DACHFORM = {
        "1000": "Flachdach",          
        "2100": "Pultdach",
        "2200": "Versetztes Pultdach",
        "3100": "Satteldach",
        "3200": "Walmdach",           
        "3300": "Krüppelwalmdach",
        "3400": "Mansarddach",        
        "3500": "Zeltdach",
        "3600": "Kegeldach",          
        "3700": "Kuppeldach",
        "3800": "Sheddach",           
        "3900": "Bogendach",
        "4000": "Turmdach",           
        "5000": "Mischform",
        "9999": "Sonstiges",
        };

    return <DossierTable title="Gemeinde" rows={!building_geometry_data ? [] : [
        ["Datenstand", format_date(building_geometry_data.source_date)],
        //["Gemeindename", municipality.name],
        [DACHFORM[building_geometry_data.roof_type_code] + ' (' + building_geometry_data.roof_segments.length + ' Flächen)', building_geometry_data.roof_area_m2, "m²"],
        //["Dachsegmente",  building_geometry_data.roof_segments.length],
        //["Dachform", DACHFORM[building_geometry_data.roof_type_code]],
        ["Fassade frei", building_geometry_data.facade_area_gross_m2, 'm²', true],
        ["davon erdberührt", building_geometry_data.facade_area_below_grade_m2, 'm²'],

        //["Davon Erdberührt", building_geometry_data.facade_area_below_grade_m2],
        //["Fassade netto", building_geometry_data.facade_area_net_m2],
        ["Fensterfläche (geschätzt)", building_geometry_data.window_area_est_m2 /*+ "" + building_geometry_data.window_area_source*/, "m²" ],
        ["Grundfläche", building_geometry_data.footprint_m2, "m²"],
        ["Firsthöhe",building_geometry_data.ridge_height_m,'m', true],
        ["Traufhöhe",building_geometry_data.eaves_height_m,'m'],
        //["Traufhöhe", building_geometry_data.eaves_height_m, "m"],
        //[building_geometry_data.storeys_definition.label, building_geometry_data.storeys],
        //["Volumen", building_geometry_data.volume_m3, "m3"],
    ]} />
}